export default (attrs) => {
  return {
    // for enum property, default view is select
    control: 'select',
    // options are all enum values
    values: attrs.enum,
  };
};
